
import { Component, Vue, Watch } from "vue-property-decorator";
import { Distinta, RigaDistinta, StatoSyncRigaDistinta, StatoVariazioneRigaDistinta } from "@/models";
import { store, StoreActions, StoreMutations } from '@/store';
import RigaDistintaListaVariazioni from './RigaDistintaListaVariazioni.vue';

@Component({
    components: {
        RigaDistintaListaVariazioni
    }
})
export default class RigheDistintaList extends Vue {
  
    get distinta(): Distinta | undefined { return store.state.distintaCorrente; }

    get righeDistintaValide(): RigaDistinta[]
    {
        if(this.distinta) {
            return this.distinta.righeDistintaDPC
                .filter(riga => {
                    if(riga.statoSincronizzazioneVariazione != StatoSyncRigaDistinta.STATO_SINCRONIZZAZIONE_VARIAZIONE_COMUNICATA_AD_AS400_MANUALMENTE)
                        return true;
                    else {
                        if(!riga.variazioniComunicate) return false;
                        let  max = Math.max(...riga.variazioniComunicate.map(va => va.indice));
                        let lastVariation = riga.variazioniComunicate.find(v => v.indice == max);
                        if(!lastVariation) return false;
                        return lastVariation.statoValidazione != StatoVariazioneRigaDistinta.RigaAggiuntaDaBC &&
                            lastVariation.statoValidazione != StatoVariazioneRigaDistinta.RigaEliminataDaBC;                        
                    }                    
                }).sort((curr, prev) => parseInt(curr.innerRigaDistinta.posizRiga) < parseInt(prev.innerRigaDistinta.posizRiga) ? -1 : 0);
        }
        return [];
    }
}
